import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

interface FirmOwnerGuardProps {
  children: ReactNode;
}

/**
 * Route guard that only allows Super Admins or Firm Owners to access firm pages.
 * Redirects others to the home page.
 */
export function FirmOwnerGuard({ children }: FirmOwnerGuardProps) {
  const { isOrgAdmin, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  // Firm Owners and Firm Admins can access firm pages
  // Owner-only actions are restricted at the component/API level
  if (!isOrgAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
